import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

/**
 * Implemented by components that own an in-progress form and want a confirmation prompt
 * before the router navigates away (nav menu, browser back, deep link, etc.).
 *
 * The component decides whether it is safe to leave and, if not, surfaces the
 * unsaved-changes confirmation itself — resolving `true` to leave, `false` to stay.
 */
export interface CanComponentDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

/**
 * Route guard that defers the "leave the page?" decision to the component. Attach it via
 * `canDeactivate: [unsavedChangesGuard]` on any route whose component implements
 * `CanComponentDeactivate`; the router blocks the navigation until the component resolves.
 */
export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = component =>
  component.canDeactivate ? component.canDeactivate() : true;
